import { getLocalApiOrigin } from '../localApi';
import { ensureClientVersion } from '../versionCheck';
import { normalizeSorceryCards } from './normalizeCards';

export const SORCERY_CARDS_ASSET_PATH = '/sorcery-cards.json';
export const SORCERY_AUTOMATION_ASSET_PATH = '/sorcery-cards-automation.json';

export function getSorceryCardsApiEndpoint(locationLike = globalThis.location) {
  return `${getLocalApiOrigin(locationLike)}/api/sorcery/cards`;
}

async function fetchCardsFrom(fetchImpl, url) {
  const response = await fetchImpl(url);

  if (!response?.ok) {
    throw new Error(`Failed to load Sorcery cards from ${url}`);
  }

  return response.json();
}

async function fetchAutomationMap(fetchImpl, locationLike) {
  try {
    const url = `${getLocalApiOrigin(locationLike)}${SORCERY_AUTOMATION_ASSET_PATH}`;
    const response = await fetchImpl(url);
    if (!response?.ok) return null;
    return await response.json();
  } catch {
    return null; // automation is optional; cards still work without it
  }
}

export async function loadSorceryCardsWithSource(fetchImpl = globalThis.fetch, locationLike = globalThis.location) {
  let lastError = null;

  // App version doubles as the foil image cache-bust token: card data +
  // images ship with a release, so it changes exactly when the card blob
  // the user downloads updates (see buildSorceryImageUrl). null in dev /
  // on fetch failure. NormalizeSorceryCards falls back to its own floor.
  const imageCacheBust = await ensureClientVersion();

  for (const [source, url] of [
    ['asset', SORCERY_CARDS_ASSET_PATH],
    ['api', getSorceryCardsApiEndpoint(locationLike)],
  ]) {
    try {
      const [cards, automationMap] = await Promise.all([
        fetchCardsFrom(fetchImpl, url),
        fetchAutomationMap(fetchImpl, locationLike),
      ]);
      return {
        cards: normalizeSorceryCards(cards, getLocalApiOrigin(locationLike), automationMap, imageCacheBust ?? undefined),
        source,
      };
    } catch (error) {
      lastError = error;
    }
  }

  throw lastError || new Error('Failed to load Sorcery cards');
}
